import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

// Globito chico anclado al botón del micrófono. NO es un modal: sin fondo oscuro, sin centrar.
// Se cierra solo a los 5s, tocando la cruz, tocando cualquier lado, o cuando la persona escribe.
// El padre lo posiciona: debe ir dentro de un contenedor con `position: relative`.
export default function MicTooltip({ show, onClose, arrow = "down", align = "left" }) {
  useEffect(() => {
    if (!show) return;
    const auto = setTimeout(onClose, 5000);
    let armDoc;
    const onDoc = () => onClose();
    // pequeño delay para no cerrarlo con el mismo ciclo en que apareció
    armDoc = setTimeout(() => document.addEventListener("pointerdown", onDoc), 60);
    return () => {
      clearTimeout(auto);
      clearTimeout(armDoc);
      document.removeEventListener("pointerdown", onDoc);
    };
  }, [show, onClose]);

  const vertical = arrow === "down" ? "bottom-full mb-2" : "top-full mt-2";
  const horizontal = align === "left" ? "left-0" : "right-0";
  const arrowV = arrow === "down"
    ? { bottom: "-5px", borderRight: "1px solid #2A2A2A", borderBottom: "1px solid #2A2A2A" }
    : { top: "-5px", borderLeft: "1px solid #2A2A2A", borderTop: "1px solid #2A2A2A" };
  const arrowH = align === "left" ? { left: "16px" } : { right: "16px" };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 6 }}
          transition={{ duration: 0.24, ease: "easeOut" }}
          className={`absolute z-40 ${vertical} ${horizontal}`}
          style={{ maxWidth: 260 }}
          role="status"
          data-testid="mic-tip"
          onPointerDown={(e) => e.stopPropagation()}
        >
          <div
            className="relative rounded-xl pl-3 pr-6 py-2"
            style={{ background: "#1A1A1A", border: "1px solid #2A2A2A", boxShadow: "0 8px 24px rgba(0,0,0,0.45)" }}
          >
            <span className="block text-crema" style={{ fontSize: 13, lineHeight: 1.35 }}>
              Revisá que se haya escrito bien antes de mandarlo.
            </span>
            <button
              onClick={(e) => { e.stopPropagation(); onClose(); }}
              className="absolute top-1 right-1 text-gris hover:text-crema transition-colors"
              data-testid="mic-tip-cerrar"
              aria-label="Cerrar"
            >
              <X size={12} />
            </button>
            <span
              className="absolute block"
              style={{ width: 10, height: 10, background: "#1A1A1A", transform: "rotate(45deg)", ...arrowV, ...arrowH }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
